import axios from "axios";
import API_ROUTES from "../../../../config/api";

const FileUpload = (companyID, file, name) => new Promise((resolve) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = async () => {
    await axios.post(API_ROUTES.onboarding['application:file-upload'](companyID), {
      data: reader.result,
      description: name,
    });

    resolve();
  };
});

export default FileUpload;
